import { TransportOperatorService } from '../../services/transport-operator/transport-operator.service'; import { TransportOperatorBusRouteService } from '../../services/transport-operator-route/transportOperatorRoute.service'; import { UserService } from '../../services/user/user.service'; import { LinkBuilder } from '../../services/link-builder.service'; import { QueryBuilder } from '../../services/query-builder.service'; import { TransportLocationService } from '../../services/transport-location/transport-location.service';

export class UsageEventManagementDialogController {
    public static $inject = [
        'transportOperatorService',
        'transportOperatorBusRouteService',
        '$mdDialog',
        '$q',
        'userService',
        'LinkBuilder',
        'QueryBuilder',
        '$translate',
        'transportLocationService'
    ];

    public currentLocale: string;
    public usageEvent: InterACT.Interfaces.UsageEvents.UsageEvent;
    public correctionCount;

    public selectedOperator: InterACT.Interfaces.TransportOperators.TransportOperator;
    public operatorSearchText: string = '';
    public selectedLocation: InterACT.Interfaces.TransportLocations.TransportLocation | InterACT.Interfaces.UsageEvents.TransportLocationLink;
    public selectedDestination: InterACT.Interfaces.TransportLocations.TransportLocation | InterACT.Interfaces.UsageEvents.TransportLocationLink;
    public selectedServiceDetail;
    public locationSearchText: string = '';

    public datestamp: Date;
    public timeStamp: string = '';

    public types = [
        'COMPLETE',
        'ENTRY',
        'EXIT',
        'UNKNOWN'
    ]

    public modes = [
        'BUS',
        'LIGHT_RAIL',
        'HEAVY_RAIL',
        'FERRY'
    ];

    public directions = [
        'INBOUND',
        'OUTBOUND',
        'CLOCKWISE',
        'ANTICLOCKWISE',
        'UNKNOWN'
    ]

    public operatorServices: Array<any> = [];

    constructor(
        private transportOperatorService: TransportOperatorService,
        private transportOperatorRouteService: TransportOperatorBusRouteService,
        private $mdDialog: ng.material.IDialogService,
        private $q: ng.IQService,
        private userService: UserService,
        private linkBuilder: LinkBuilder,
        private queryBuilder: QueryBuilder,
        private $translate: ng.translate.ITranslateService,
        private transportLocationService: TransportLocationService
    ) {
        this.activate();
    }

    /**
     * A method that retrieves the transport operators that satisfy the supplied search text
     * @param searchText the search text to use to locate a transport operator
     */
    public getTransportOperators = (searchText: string) => {
        const deferred = this.$q.defer();

        if (!searchText) {
            deferred.resolve([]);
        }

        const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
        const builder = this.queryBuilder.newParam()
            .openSubQuery()
            .fieldIs('schemes.link', schemeLink)
            .or()
            .fieldIs('schemes.link', '/globalScheme')
            .closeSubQuery();

        if (searchText !== '') {
            builder.and()
                .fieldContains('name.' + this.currentLocale, searchText)
        }

        const query = builder.getParam();

        this.transportOperatorService.getList(1, 1000, query).then((response) => {
            deferred.resolve(response.transportOperators);
        });

        return deferred.promise;
    }

    /**
     * A method that retrieves the transport locations that satisfy the supplied location name
     * @param searchText the name of the location to search for
     */
    public getTransportLocations = (searchText: string) => {
        const deferred = this.$q.defer();
        const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
        const builder = this.queryBuilder.newParam()
            .openSubQuery()
            .fieldIs('scheme.link', schemeLink)
            .or()
            .fieldIs('scheme.link', '/globalScheme')
            .closeSubQuery();

        if (searchText) {
            builder.and().openSubQuery()
                .fieldContains('references.atcoCode', searchText)
                .or().fieldContains('references.naptanCode', searchText)
                .or().fieldContains('locationName', searchText)
                .closeSubQuery();
        }

        const query = builder.getParam();

        this.transportLocationService.getList(1, 1000, query).then((response) => {
            deferred.resolve(response.transportLocations);
        });

        return deferred.promise;
    }

    /**
     * A method that gets the text that should be displayed for a transport location
     */
    public getLocationText = (transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) => {

        const locationName = transportLocation.locationName;

        if (transportLocation.references) {
            if ((<any>transportLocation.references).atcoCode) {
                return (<any>transportLocation.references).atcoCode + ' - ' + locationName;
            }

            if ((<any>transportLocation.references).naptanCode) {
                return (<any>transportLocation.references).naptanCode + ' - ' + locationName;
            }
        }

        return locationName;
    }

    /**
     * A method that gets the text that should be displayed for an operator
     */
    public getOperatorText = (transportOperator: InterACT.Interfaces.TransportOperators.TransportOperator) => {
        return transportOperator.name[this.currentLocale];
    }

    /**
     * A method that updates the usage event
     * @param fieldType the type of field to update
     */
    public updateSelected = (fieldType: string) => {

        switch (fieldType) {

            case "location":
                if (!this.selectedLocation) {
                    this.usageEvent.location.locationName = undefined;
                    this.usageEvent.location.link = undefined;
                    return;
                }

                this.usageEvent.location.locationName = this.selectedLocation.locationName;
                this.usageEvent.location.link = this.linkBuilder.getTransportLocationLink((<any>this.selectedLocation).id);
                break;

            case "destination":
                if (!this.selectedDestination) {
                    this.usageEvent.destinationLocation.locationName = undefined;
                    this.usageEvent.destinationLocation.link = undefined;
                    return;
                }

                this.usageEvent.destinationLocation.locationName = this.selectedDestination.locationName;
                this.usageEvent.destinationLocation.link = this.linkBuilder.getTransportLocationLink((<any>this.selectedDestination).id);
                break;

            case "operator":
                if (!this.selectedOperator) {
                    this.usageEvent.operator.name = undefined;
                    this.usageEvent.operator.reference = undefined;
                    this.usageEvent.operator.link = undefined;
                    return;
                }

                this.usageEvent.operator.reference = this.selectedOperator.id;
                this.usageEvent.operator.link = this.linkBuilder.getTransportOperatorsLink((<any>this.selectedOperator).id);
                this.usageEvent.operator.name = this.selectedOperator.name[this.currentLocale];

                this.getServicesForOperator(this.selectedOperator.id);

                break;

            case 'date':
            case "time":
                if (!this.timeStamp) {
                    this.usageEvent.timestamp = undefined;
                    return;
                }

                let timeParts = this.timeStamp.split(':');
                const seconds = timeParts.length > 2 ? parseInt(timeParts[2]) : 0;

                let date = this.datestamp.setHours(
                    parseInt(timeParts[0]),
                    parseInt(timeParts[1]),
                    seconds,
                    0);

                let finalDate = new Date(date).toISOString();
                this.usageEvent.timestamp = finalDate;
                break;

            case "service":
                if (!this.selectedServiceDetail) {
                    this.usageEvent.serviceDetail = <any>{
                        name: undefined,
                        link: undefined,
                        reference: undefined
                    }
                }
                this.usageEvent.serviceDetail = <any>{
                    name: this.selectedServiceDetail.serviceNumber,
                    link: this.linkBuilder.getTransportOperatorServicesLink(this.selectedServiceDetail.id),
                    reference: this.selectedServiceDetail.serviceNumber
                }
                break;
        }
    }

    public shouldShowDestination = () => {
        if (this.usageEvent.type !== 'COMPLETE') {
            return false;
        }
        return true;
    }

    /**
     * A method to populate the usage event date if a usage event is passed to the dialog
     */
    public populateData = () => {
        if (this.usageEvent.id) {

            if (this.usageEvent.timestamp) {
                this.datestamp = this.formatDateStamp(this.usageEvent.timestamp);
                this.timeStamp = this.formatTimeStamp(this.usageEvent.timestamp);
            }

            if (this.usageEvent.location && this.usageEvent.location.locationName) {
                this.selectedLocation = this.usageEvent.location;
            }

            if (this.usageEvent.destinationLocation && this.usageEvent.destinationLocation.locationName) {
                this.selectedDestination = this.usageEvent.destinationLocation;
            }

            if (this.usageEvent.mode) {
                this.usageEvent.mode = this.usageEvent.mode.toUpperCase();
            }

            if (this.usageEvent.operator && this.usageEvent.operator.link) {
                this.operatorSearchText = this.usageEvent.operator.name;
                this.getServicesForOperator(this.usageEvent.operator.link.split('/').pop()).then((operatorServices) => {

                    //WRITE UNIT TEST TO TEST THAT SELECTED SERVICE GETS SET //////////////////////////////////////////////////////////////////////////////////////////////////
                    this.setSelectedService(operatorServices);
                });
            }
        }
    }

    /**
     * Function which is used to complete a dialog action
     */
    public ok = () => {
        this.$mdDialog.hide();
    }

    private setSelectedService(operatorServices: Array<InterACT.Interfaces.TransportOperatorServices.TransportOperatorService>) {
        if (!this.usageEvent.serviceDetail) {
            return;
        }

        this.selectedServiceDetail = operatorServices.filter((operatorService) => {
            return operatorService.id === this.usageEvent.serviceDetail.link.split('/').pop();
        }).pop();
    }

    /**
     * A method that is called during controller instantiation
     */
    private activate() {
        this.currentLocale = this.$translate.use();
    }

    private formatTimeStamp = (timeStamp: string) => {
        return timeStamp.split('T').pop().split('Z').shift().split('.').shift()
    }

    private formatDateStamp = (dateStamp: string) => {
        return new Date(dateStamp.split('T').shift());
    }

    /**
     * A method to get the services for a selected operator
     * @param id the id of the selected operator
     */
    private getServicesForOperator(id: string) {
        const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
        const builder = this.queryBuilder.newParam()
            .openSubQuery()
            .fieldIs('schemes.link', schemeLink)
            .or()
            .fieldIs('schemes.link', '/globalScheme')
            .closeSubQuery()
            .and()
            .fieldIs('operator.link', this.linkBuilder.getTransportOperatorsLink(id))

        const query = builder.getParam();

        return this.transportOperatorRouteService.getList(1, 1000, query).then((response) => {
            this.operatorServices = response;
            return response;
        });
    }
}